/**
 * UNIVERSAL BLOCKED ACTIONS
 * Smart Shikka must NEVER perform these actions automatically.
 * These are safety constants shared across all apps.
 */
export const UNIVERSAL_BLOCKED_ACTIONS = [
    {
        id: 'auto_save',
        label_hi: 'Auto Save',
        severity: 'critical',
        reason_hi: 'Save action requires explicit user confirmation.',
    },
    {
        id: 'auto_submit',
        label_hi: 'Auto Submit',
        severity: 'critical',
        reason_hi: 'Submit action requires explicit user confirmation.',
    },
    {
        id: 'auto_post',
        label_hi: 'Auto Post',
        severity: 'critical',
        reason_hi: 'Posting requires explicit user confirmation.',
    },
    {
        id: 'auto_delete',
        label_hi: 'Auto Delete',
        severity: 'critical',
        reason_hi: 'Delete is irreversible. User must confirm.',
    },
    {
        id: 'auto_file_gst_return',
        label_hi: 'Auto File GST Return',
        severity: 'critical',
        reason_hi: 'GST filing is a legal action. Only user can file.',
    },
    {
        id: 'auto_payment',
        label_hi: 'Auto Payment',
        severity: 'critical',
        reason_hi: 'Payment requires explicit user authorization.',
    },
    {
        id: 'auto_refund',
        label_hi: 'Auto Refund',
        severity: 'critical',
        reason_hi: 'Refund requires explicit user authorization.',
    },
    {
        id: 'mutate_role',
        label_hi: 'Mutate Role',
        severity: 'critical',
        reason_hi: 'Role changes must never be done by AI.',
    },
    {
        id: 'mutate_license',
        label_hi: 'Mutate License',
        severity: 'critical',
        reason_hi: 'License changes must never be done by AI.',
    },
    {
        id: 'mutate_rls',
        label_hi: 'Mutate RLS',
        severity: 'critical',
        reason_hi: 'Row-level security policies must never be changed by AI.',
    },
    {
        id: 'mutate_secret',
        label_hi: 'Mutate Secret/API Key',
        severity: 'critical',
        reason_hi: 'Secrets and API keys must never be touched by AI.',
    },
    {
        id: 'mutate_formula',
        label_hi: 'Mutate Formula',
        severity: 'high',
        reason_hi: 'Formula/calculation changes require user review.',
    },
    {
        id: 'mutate_balance',
        label_hi: 'Mutate Balance',
        severity: 'critical',
        reason_hi: 'Balance/financial values must not be auto-modified.',
    },
    {
        id: 'export_or_send_without_user_confirmation',
        label_hi: 'Export/Send Without Confirmation',
        severity: 'critical',
        reason_hi: 'Exporting or sending data requires explicit user confirmation.',
    },
];
export const UNIVERSAL_BLOCKED_ACTION_IDS = UNIVERSAL_BLOCKED_ACTIONS.map((a) => a.id);
//# sourceMappingURL=blockedActions.js.map